// export const organization = {
//   routes: [
//     {
//       path: "/organization/file-manager",
//       component: () => import("../file-manager-view"),
//     },
//   ],
// };

export const fwsed = {
  routes: [
    {
      path: "/fwsed/file-manager",
      component: () => import("../fwsed-file-manager-view"),
    },
  ],
};
